import type { PageableResponse } from '../types';
import type {
  CreateEducationClassBody,
  EducationClass,
  EducationClassListRequest,
  UpdateEducationClassBody,
} from './types';
import { api } from '../api';

export const educationClassesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEducationClassList: build.query<PageableResponse<EducationClass>, EducationClassListRequest>(
      {
        query: (params) => ({
          url: '/educational-classes',
          params: { ...params },
        }),
        keepUnusedDataFor: 30,
        providesTags: ['EducationClasses'],
      },
    ),
    createEducationClass: build.mutation<EducationClass, CreateEducationClassBody>({
      query: (body) => ({
        url: '/educational-classes',
        method: 'POST',
        body: { ...body, litera: typeof body.litera === 'string' ? [body.litera] : body.litera },
      }),
      invalidatesTags: ['EducationClasses'],
    }),
    updateEducationClass: build.mutation<EducationClass, UpdateEducationClassBody>({
      query: ({ id, ...body }) => ({
        url: `/educational-classes/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['EducationClasses'],
    }),
    deleteEducationClass: build.mutation<EducationClass, number>({
      query: (id) => ({
        url: `/educational-classes/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EducationClasses'],
    }),
  }),
});

export const {
  useGetEducationClassListQuery,
  useCreateEducationClassMutation,
  useUpdateEducationClassMutation,
  useDeleteEducationClassMutation,
} = educationClassesApi;
